import { Component, OnInit, ElementRef } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import {  ViewChild } from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {ValidateService} from '../../services/validate.service';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes, Router} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';
import { SetdataService } from '../../services/setdata.service';
@Component({
  selector: 'app-edit-workgroup',
  templateUrl: './edit-workgroup.component.html',
  styleUrls: ['./edit-workgroup.component.css']
})
export class EditWorkgroupComponent implements OnInit {

  constructor(private validateService:ValidateService,private router:Router, private setDataService:SetdataService,private deletedataService:DeletedataService, private authService:AuthenticationService,  private route: ActivatedRoute,private _flashMessagesService: FlashMessagesService,private getdataService:GetdataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) { }

  user; 
  meetingrooms:MeetingRooms[];
  group_id;
  workgroupData;
  public submitted:boolean;
  editgroupname;

  ngOnInit() {
    this.refreshEverything();
  }

  refreshEverything = () => {
    this.submitted=true;
    this.group_id = this.route.snapshot.paramMap.get('id');  
    this.authService.getProfile().subscribe((user) => {
      
      this.user=  user;
      this.getdataService.getWorkGroupsByWorkgroupID(this.group_id).subscribe((WorkGroupData) => {
      this.workgroupData=  WorkGroupData;
      this.editgroupname = this.workgroupData[0].workgroup_name;
          this.getdataService.getMeetingRoomsByAccount(this.user[0].user.account_ID).subscribe((meetingrooms) => {
            this.meetingrooms=  meetingrooms;
            //console.log(this.workgroupData)
              for(let i=0; i<this.meetingrooms.length ; i++)
              {
                for(let u=0; u<this.workgroupData[0].roomID_Array.length; u++)
                {

                  if(this.workgroupData[0].roomID_Array[u].roomID == this.meetingrooms[i]._id)
                  {
                    this.meetingrooms[i].checked = "checked";
                  }
                } 
              }

            },
          err=>{
            return false;
          });
          this.submitted=false;
        },
        err=>{
          return false;
        });
  },

  err=>{
    return false;
  });
  }


  setWorkGroupRooms = () => {

    this.submitted=true;

    let workgroupname = this.elem.nativeElement.querySelector('#editgroupname').value;

  this.authService.getProfile().subscribe((user) => {
   this.user=  user;
   //////console.log(this.user[0].user.account_ID);

   let AccountAvailableRooms = [];
   let AccountAvailableRoomsNames = [];
   $('#room_checkboxes :checked').each(function() {
     AccountAvailableRooms.push($(this).val());
   });
   ////console.log("label");
   for(let z=0;z<AccountAvailableRooms.length;z++)
   {
     ////console.log($("#label_"+AccountAvailableRooms[z]).text())
     AccountAvailableRoomsNames.push($("#label_"+AccountAvailableRooms[z]).text());
   }


   ////console.log(workgroupname);
   let formData = new FormData();
   formData.append('workgroup_name',workgroupname);
   formData.append('workgroup_id',this.group_id);
   formData.append('account_ID',  this.user[0].user.account_ID);
   ////console.log("account available lenght"+AccountAvailableRooms.length);
   if(AccountAvailableRooms.length>1)
   {
     formData.append('one','notone');
     ////console.log('appended form not one');
     for(let i=0; i<AccountAvailableRooms.length;i++)
     {
       formData.append('roomID_Array',AccountAvailableRooms[i]);
       formData.append('room_Name',AccountAvailableRoomsNames[i]);
     }
   }else{
     formData.append('one','one');
     ////console.log('appended form is one');
     let accountAvailableRooms  = JSON.parse(JSON.stringify(AccountAvailableRooms[0]));
     let accountAvailableRoomsName  = JSON.parse(JSON.stringify(AccountAvailableRoomsNames[0]));
     formData.append('roomID_Array',accountAvailableRooms);
     formData.append('room_Name',accountAvailableRoomsName);
   }


       this.setDataService.setWorkGroup(formData).subscribe
       (res =>{
             this._flashMessagesService.show('Success: Workgroup edited successfully', {cssClass: 'center-align flow-text card-title z-depth-2 white-text green darken-3', timeout:5000});

             ////////refresh category /////////////
                  this.refreshEverything();
                  this.submitted=false;
                  this.router.navigate(['/admin/workgroup']);
           //////////end refresh category.////////

     } );




 },
err=>{
 //////console.log(err);
 return false;
});


}


}


interface MeetingRooms{
  _id:string,
  room_name:string,
  room_place:string,
  room_default_logo:string,
  room_default_logo_path:string,
  room_type:string,
  room_floor_number:string,
  room_slider_ID:string,
  checked:string
}


// WEBPACK FOOTER //
// ./src/app/components/edit-workgroup/edit-workgroup.component.ts